import Vue from 'vue'
import Router from 'vue-router'

import ContentUnit from '@/views/components/ContentUnit.vue'
import ContentUnitSingle from '@/views/components/ContentUnitSingle.vue'
import Korkeakoulu from '@/views/Korkeakoulu'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      // redirect: `/${defaultLocale}`
      redirect: '/fi/etusivu'
    },
    {
      path: '/:locale',
      component: {
        template: '<router-view />',
      },
      /* this never worked
      beforeEnter: (to, from, next) => {
        const lang = to.params.locale
        // $i18n.locale = lang
        return next()
      }, */
      redirect: '/:locale/etusivu',
      children: [
        {
          path: 'etusivu',
          name: 'Korkeakoulu',
          component: Korkeakoulu
        },
        {
          path: 'immateriaalioikeudet',
          name: 'Immateriaalioikeudet',
          component: ContentUnit,
          props: {
            pid: 9,
            pids: [9, 397, 398],
            colorclass: 'template-red',
            herosrc: 1
          }
        },
        {
          path: 'mitatekijanoikeustarkoittaa',
          name: 'MitaTekijanoikeusTarkoittaa',
          component: ContentUnit,
          props: {
            pid: 25,
            pids: [25, 399, 401],
            colorclass: 'template-blue',
            herosrc: 2
          }
        },
        {
          path: 'tekijanoikeuksienluovuttaminen',
          name: 'TekijanoikeuksienLuovuttaminen',
          component: ContentUnit,
          props: {
            pid: 26,
            pids: [26, 440, 441],
            colorclass: 'template-yellow',
            herosrc: 3
          }
        },
        {
          path: 'teostenkaytto',
          name: 'TeostenKaytto',
          component: ContentUnit,
          props: {
            pid: 27,
            pids: [27, 459, 460],
            colorclass: 'template-green',
            herosrc: 4
          }
        },
        {
          path: 'omantuottamisenprosessi',
          name: 'OmanTuottamisenProsessi',
          component: ContentUnit,
          props: {
            pid: 28,
            pids: [28, 493, 494],
            colorclass: 'template-purple',
            herosrc: 5
          }
        },
        {
          path: 'info',
          name: 'Info',
          component: ContentUnitSingle,
          props: {
            pid: 164,
            pids: [164, 517, 518],
            colorclass: '',
            herosrc: 0
          }
        },
        {
          path: 'ohjeet',
          name: 'Info page',
          component: ContentUnitSingle,
          props: {
            pid: 164,
            pids: [164, 517, 518],
            colorclass: '',
            herosrc: 0
          }
        },
        {
          path: 'tekijat',
          name: 'Tekijät',
          component: ContentUnitSingle,
          props: {
            pid: 165,
            pids: [165, 543, 544],
          }
        },
        {
          path: 'kayttoehdot',
          name: 'Käyttöehdot',
          component: ContentUnitSingle,
          props: {
            pid: 166,
            pids: [166, 537, 538],
          }
        },
        {
          path: 'evasteet',
          name: 'Evästeet ',
          component: ContentUnitSingle,
          props: {
            pid: 167,
            pids: [167, 541, 542],
          }
        },
        {
          path: 'osaamismerkki',
          name: 'Osaamismerkki',
          component: ContentUnitSingle,
          props: {
            pid: 168,
            pids: [168, 577, 578],
          }
        },
        {
          path: 'yhteystiedot',
          name: 'Yhteystiedot',
          component: ContentUnitSingle,
          props: {
            pid: 183,
            pids: [183, 539, 540],
          }
        },
        {
          path: 'tietosuojakaytanto',
          name: 'Tietosuojakaytanto',
          component: ContentUnitSingle,
          props: {
            pid: 674,
            pids: [674, 677, 681],
          }
        },
        {
          path: 'opettajalle',
          name: 'Opettajalle',
          component: ContentUnitSingle,
          props: {
            pid: 382,
            pids: [180, 519, 520],
          }
        }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js